import { Stack } from "@similarweb/ui-components/foundations";

import { RecentCampaignsTable } from "../advertisers/overview/components/RecentCampaignsTable";
import { CountryMapWidget } from "../common/overview/CountryMapWidget";
import { PerformanceOverTimeGraph } from "./performance-over-time/PerformanceOverTimeGraph";
import { SearchCampaignsTable } from "./search-campaigns/SearchCampaignsTable";
import { TrackedActivityEstimates } from "./tracked-activity-estimates/TrackedActivityEstimates";

export const AdvertiserActivityOverviewPage = () => {
    return (
        <>
            <Stack gap="24px">
                <TrackedActivityEstimates />
                <PerformanceOverTimeGraph />
                <CountryMapWidget
                    methodName="adIntelligenceAdvertiserWorldMapMergedDataList"
                    titleKey="ad.intelligence.advertiser.activity.overview.countries.map.title"
                    tooltipKey="ad.intelligence.advertiser.activity.overview.countries.map.tooltip"
                />
                <RecentCampaignsTable
                    withPagination
                    title="ad.intelligence.advertiser.recent.display.campaigns.table.title"
                />
            </Stack>
            <SearchCampaignsTable />
        </>
    );
};
